import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Headset = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 2.00005H15C10.037 2.00005 6 6.03705 6 11V18C6 20.2 7.8 22 10 22C12.2 22 14 20.2 14 18V16C14 13.8 12.2 12 10 12H8V11C8 7.13805 11.137 4.00005 15 4.00005H17C20.863 4.00005 24 7.13805 24 11V12H22C19.8 12 18 13.8 18 16V18C18 20.2 19.8 22 22 22C22.725 22 23.413 21.8 24 21.462V22.937C24 24.587 22.65 25.937 21 25.937H19.812C19.374 24.812 18.287 23.999 16.999 23.999H14.999C13.349 23.999 11.999 25.349 11.999 26.999C11.999 28.649 13.349 29.999 14.999 29.999H16.999C18.324 29.999 19.449 29.136 19.849 27.936H20.999C23.761 27.936 25.999 25.698 25.999 22.936V10.998C25.999 6.03505 21.961 1.99805 16.999 1.99805L17 2.00005ZM10 14C11.1 14 12 14.9 12 16V18C12 19.1 11.1 20 10 20C8.9 20 8 19.1 8 18V14H10ZM17 28H15C14.45 28 14 27.55 14 27C14 26.45 14.45 26 15 26H17C17.55 26 18 26.45 18 27C18 27.55 17.55 28 17 28ZM22 20C20.9 20 20 19.1 20 18V16C20 14.9 20.9 14 22 14H24V18C24 19.1 23.1 20 22 20Z" />
	</svg>
);

export default Headset;
